/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:2e02535e-c852-4afc-ac44-1df93d252a4b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Yc8JVl1Y6",
    "aws_user_pools_web_client_id": "1fou7n6mumkvu3cu69155igp2n",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_mobile_analytics_app_id": "2960b75417aa4a15ab9422b8f2d14853",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "2960b75417aa4a15ab9422b8f2d14853",
            "region": "us-east-1"
        }
    }
};


export default awsmobile;
